@if (label) {
  <label
    class="ui-label ui-label--{{ labelSize }}"
    [ngClass]="{ 'ui-label--required': isRequired }"
    [attr.for]="inputId"
    >{{ label }}</label
  >
}

<div class="ui-input__container">
  <ng-content select=".addon-prepend"></ng-content>

  @if (isTextField) {
    <dx-text-box
      ngSkipHydration
      #input
      [placeholder]="placeholder"
      [value]="value"
      [readOnly]="readOnly"
      [disabled]="disabled"
      [mode]="mode"
      (valueChange)="onValueChanged($event)"
      (onFocusIn)="onFocusIn($event)"
      (onFocusOut)="onFocusOut($event)"
      (keydown)="onKeyDown($event)"
      (keyup)="onKeyUp($event)"
      (keypress)="onKeyPress($event)"
      [valueChangeEvent]="valueChangeEvent"
      validationMessageMode="always"
      [inputAttr]="inputAttrs"
      [mask]="mask"
      [maskInvalidMessage]="maskInvalidMessage"
      [useMaskedValue]="false"
      showMaskMode="onFocus"
      [showClearButton]="showClearButton"
      [maxLength]="maxLength"
      [hoverStateEnabled]="false"
      [stylingMode]="stylingMode"
      [tabIndex]="tabIndex"
      [isValid]="isValid"
      (isValidChange)="onIsValidChanged($event)"
      [(validationError)]="validationError"
    >
      @if (hasRules) {
        <dx-validator>
          @for (rule of rules; track rule) {
            <dxi-validation-rule
              [type]="rule.type"
              [message]="rule.message"
              [min]="rule.min"
              [max]="rule.max"
              [pattern]="rule.pattern"
              [comparisonTarget]="rule.comparisonTarget"
              [validationCallback]="rule.validationCallback"
            ></dxi-validation-rule>
          }
        </dx-validator>
      }
    </dx-text-box>
  }

  @if (isTextareaField) {
    <dx-text-area
      ngSkipHydration
      [placeholder]="placeholder"
      [value]="value"
      [readOnly]="readOnly"
      [disabled]="disabled"
      (valueChange)="onValueChanged($event)"
      (onFocusOut)="onFocusOut($event)"
      validationMessageMode="always"
      [inputAttr]="inputAttrs"
      [maxLength]="maxLength"
      [hoverStateEnabled]="false"
      [stylingMode]="stylingMode"
      [tabIndex]="tabIndex"
      [valueChangeEvent]="valueChangeEvent"
      (isValidChange)="onIsValidChanged($event)"
    >
      @if (hasRules) {
        <dx-validator>
          @for (rule of rules; track rule) {
            <dxi-validation-rule
              [type]="rule.type"
              [message]="rule.message"
              [min]="rule.min"
              [max]="rule.max"
            ></dxi-validation-rule>
          }
        </dx-validator>
      }
    </dx-text-area>
  }

  @if (isNumberField) {
    <dx-number-box
      ngSkipHydration
      [placeholder]="placeholder"
      [value]="value"
      [readOnly]="readOnly"
      [disabled]="disabled"
      (valueChange)="onValueChanged($event)"
      [format]="numericFormat"
      (onFocusOut)="onFocusOut($event)"
      [min]="min"
      [max]="max"
      validationMessageMode="always"
      [inputAttr]="inputAttrs"
      [step]="0"
      [hoverStateEnabled]="false"
      [stylingMode]="stylingMode"
      [tabIndex]="tabIndex"
      [valueChangeEvent]="valueChangeEvent"
      (isValidChange)="onIsValidChanged($event)"
    >
      @if (hasRules) {
        <dx-validator>
          @for (rule of rules; track rule) {
            <dxi-validation-rule
              [type]="rule.type"
              [message]="rule.message"
              [min]="rule.min"
              [max]="rule.max"
            ></dxi-validation-rule>
          }
        </dx-validator>
      }
    </dx-number-box>
  }

  @if (isCheckboxField) {
    <dx-check-box
      ngSkipHydration
      [ngClass]="{ 'has-label': hasLabel }"
      [text]="placeholder"
      [value]="value"
      [readOnly]="readOnly"
      [disabled]="disabled"
      (valueChange)="onValueChanged($event)"
      (onFocusOut)="onFocusOut($event)"
      [focusStateEnabled]="false"
    >
      @if (hasRules) {
        <dx-validator>
          @for (rule of rules; track rule) {
            <dxi-validation-rule [type]="rule.type" [message]="rule.message"></dxi-validation-rule>
          }
        </dx-validator>
      }
    </dx-check-box>
  }

  @if (isDateField) {
    <dx-date-box
      ngSkipHydration
      [placeholder]="placeholder"
      [value]="value"
      [readOnly]="readOnly"
      [disabled]="disabled"
      [openOnFieldClick]="true"
      [showDropDownButton]="false"
      (valueChange)="onValueChanged($event)"
      (onFocusOut)="onFocusOut($event)"
      validationMessageMode="always"
      [inputAttr]="inputAttrs"
      displayFormat="dd/MM/yyyy"
      [hoverStateEnabled]="false"
      [stylingMode]="stylingMode"
      [tabIndex]="tabIndex"
    >
      @if (hasRules) {
        <dx-validator>
          @for (rule of rules; track rule) {
            <dxi-validation-rule [type]="rule.type" [message]="rule.message"></dxi-validation-rule>
          }
        </dx-validator>
      }
    </dx-date-box>
  }

  <ng-content select=".addon-append"></ng-content>
</div>

@if (helper) {
  <p class="ui-helper">
    {{ helper }}
  </p>
}

<ng-content />
